import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Box, Checkbox, Container, FormControl, FormControlLabel, Grid, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from '@material-ui/core';
import numero from 'numero-por-extenso';
import { format, parse } from 'date-fns';
import { PLANOS_2025 } from './planos';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  margin: {
    margin: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));


export default function Contrato() {
  const classes = useStyles();
  const [campos, setCampos] = useState({
    periodicidade: 'MENSAL',
    diaVencimento: 10,
    dataContrato: format(new Date(), 'dd/MM/yyyy'),
    dataContratoOriginal: '',
    formaPagamentoImplantacao: 'PIX',
    formaPagamentoMensalidade: 'BOLETO',
  });

  const [isChecked, setChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };

  function snapValorPorPeriodicidade(next, calcularPlanos) {
    const vMensal = parseFloat(next.valorMensalidade || 0);
    const calculados = calcularPlanos ? calcularPlanos(vMensal) : {};
    const safe = (s, fallback) => (s && String(s).trim() !== '' ? s : fallback);

    switch ((next.periodicidade || 'MENSAL').toUpperCase()) {
      case 'TRIMESTRAL':
        return { rotulo: 'trimestral', valor: safe(next.valorTrimestral, calculados.valorTrimestral || formatBRL(vMensal * 3 * 0.97)) };
      case 'SEMESTRAL':
        return { rotulo: 'semestral', valor: safe(next.valorSemestral, calculados.valorSemestral || formatBRL(vMensal * 6 * 0.94)) };
      case 'ANUAL':
        return { rotulo: 'anual', valor: safe(next.valorAnual, calculados.valorAnual || formatBRL(vMensal * 12 * 0.88)) };
      case 'BIANUAL':
        return { rotulo: 'bienal', valor: safe(next.valorBienal, calculados.valorBienal || formatBRL(vMensal * 24 * 0.76)) };
      default:
        return { rotulo: 'mensalidade', valor: formatBRL(vMensal) };
    }
  }

  function obterPlanoLabel(next) {
    if (next.planoSelecionado && PLANOS_2025[next.planoSelecionado]) {
      return PLANOS_2025[next.planoSelecionado].label;
    }
    // fallback: se você usa o campo de texto "plano" como descrição
    if (next.plano) return next.plano;
    return ''; // opcional: usar next.sistemaContratado
  }

  const LABEL_FORMA = { PIX: 'PIX', CARTAO: 'Cartão', BOLETO: 'Boleto' };

  const formatBRL = (n) =>
    (isNaN(n) ? 0 : n).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  function calcularPlanos(valorMensal) {
    const v = parseFloat(valorMensal || 0);
    if (isNaN(v) || v <= 0) {
      return {
        valorTrimestral: '', valorSemestral: '', valorAnual: '', valorBienal: '',
        valorTrimestralExtenso: '', valorSemestralExtenso: '', valorAnualExtenso: '', valorBienalExtenso: '',
      };
    }

    const planos = [
      { key: 'Trimestral', meses: 3, desconto: 3 },
      { key: 'Semestral', meses: 6, desconto: 6 },
      { key: 'Anual', meses: 12, desconto: 12 },
      { key: 'Bienal', meses: 24, desconto: 24 },
    ];

    const out = {};
    planos.forEach(({ key, meses, desconto }) => {
      const total = v * meses * (1 - desconto / 100);
      out[`valor${key}`] = formatBRL(total);
      out[`valor${key}Extenso`] = numero.porExtenso(
        Math.round(total * 100) / 100,
        numero.estilo.monetario
      );
    });

    return out;
  }

  const handlePaste = (event) => {
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData('text');

    // Verificar se o texto colado é uma data válida
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(pastedText)) {
      const date = parse(pastedText, 'dd/MM/yyyy', new Date())
      const formatedDate = format(date, 'yyyy-MM-dd')
      setCampos(state => ({ ...state, dataContratoOriginal: formatedDate }))
    } else {
      // Impedir a colagem se o texto não for uma data válida
      event.preventDefault();
    }
  };

  const handleSaveToPC = (jsonData, filename) => {
    const fileData = JSON.stringify(jsonData);
    const blob = new Blob([fileData], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.download = `${filename}.json`;
    link.href = url;
    link.click();
  }



  function onclickSave() {
    const data = format(new Date(), 'dd/MM/yyyy')

    const camposCopy = { ...campos }

    if (isChecked) {
      const dataContratoOriginalDate = parse(camposCopy.dataContratoOriginal, 'yyyy-MM-dd', new Date())

      camposCopy.dataContratoOriginal = format(dataContratoOriginalDate, 'dd/MM/yyyy')
    }
    handleSaveToPC(camposCopy, `${camposCopy.razaoSocial}_${data}`)
  }

  function gerarResumoPagamento(next, calcularPlanos) {
    const plano = obterPlanoLabel(next) || '—';
    const implant = formatBRL(parseFloat(next.valorImplantacao || 0));
    const info = snapValorPorPeriodicidade(next, calcularPlanos);
    const periodicidade = (next.periodicidade || 'MENSAL').toLowerCase();

    const formaImplant = LABEL_FORMA[next.formaPagamentoImplantacao] || 'PIX';
    const formaMensal = LABEL_FORMA[next.formaPagamentoMensalidade] || 'PIX';

    return [
      `Plano: ${plano}`,
      `Implantação: ${implant} (${formaImplant})`,
      `Periodicidade: ${periodicidade}`,
      `${info.rotulo.charAt(0).toUpperCase() + info.rotulo.slice(1)}: ${info.valor} (${formaMensal})`
    ].join('\n');
  }

  function handleChange(event) {
    const nomeCampo = event.target.name;
    const valorCampo = event.target.value;
    const tipo = event.target.type;

    // cópia base
    let proximo = { ...campos };

    // 1) seleção de plano: define valores, extenso, itens do plano e recalcula descontos
    if (nomeCampo === 'planoSelecionado') {
      const plano = PLANOS_2025 && PLANOS_2025[valorCampo];

      if (plano) {
        proximo.planoSelecionado = valorCampo;

        // valores
        proximo.valorMensalidade = plano.mensalidade;
        proximo.valorMensalidadeExtenso = numero.porExtenso(plano.mensalidade, numero.estilo.monetario);

        proximo.valorImplantacao = plano.implantacao;
        proximo.valorImplantacaoExtenso = numero.porExtenso(plano.implantacao, numero.estilo.monetario);

        // *** NOVO: horas do plano ***
        proximo.horaTreinamento = plano.hours
        proximo.horaTreinamentoExtenso = numero.porExtenso(plano.hours, numero.estilo.normal) + ' horas'

        // itens do plano (texto multilinha no campo "plano")
        proximo.plano = plano.descricao || '';

        // descontos (3/6/12/24)
        if (typeof calcularPlanos === 'function') {
          Object.assign(proximo, calcularPlanos(plano.mensalidade));
        }

        // resumo auto
        if (typeof gerarResumoPagamento === 'function') {
          proximo.resumoPagamento = gerarResumoPagamento(
            proximo,
            typeof calcularPlanos === 'function' ? calcularPlanos : undefined
          );
        }

        setCampos(proximo);
        return;
      }

      // se não achar o plano (valor vazio ou custom), só seta o campo
      proximo.planoSelecionado = valorCampo;
      setCampos(proximo);
      return;
    }

    // 2) numéricos: atualiza + extenso; se for mensalidade, recalcula descontos
    if (tipo === 'number') {
      proximo[nomeCampo] = valorCampo;

      // extenso monetário
      const n = parseFloat(valorCampo || 0);
      proximo[nomeCampo + 'Extenso'] = numero.porExtenso(isNaN(n) ? 0 : n, numero.estilo.monetario);

      if (nomeCampo === 'valorMensalidade' && typeof calcularPlanos === 'function') {
        Object.assign(proximo, calcularPlanos(valorCampo));
      }
    }
    // 3) telefone (usado para horas de treino no seu form): extenso normal + " horas"
    else if (tipo === 'tel') {
      proximo[nomeCampo] = valorCampo;

      const n = parseFloat(valorCampo || 0);
      proximo[nomeCampo + 'Extenso'] =
        numero.porExtenso(isNaN(n) ? 0 : n, numero.estilo.normal) + ' horas';
    }
    // 4) demais campos (select, text etc.)
    else {
      proximo[nomeCampo] = valorCampo;
    }

    // 5) campos que disparam a atualização do resumo
    const disparaResumo = new Set([
      'planoSelecionado',
      'periodicidade',
      'valorMensalidade',
      'valorImplantacao',
      'formaPagamentoImplantacao',
      'formaPagamentoMensalidade',
    ]);



    if (disparaResumo.has(nomeCampo) && typeof gerarResumoPagamento === 'function') {
      proximo.resumoPagamento = gerarResumoPagamento(
        proximo,
        typeof calcularPlanos === 'function' ? calcularPlanos : undefined
      );
    }

    setCampos(proximo);
  }


  return (
    <Container maxWidth='md'>

      <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
        Contrato
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            onChange={handleCheckboxChange}
            name="checkboxContratoOriginal"
          />
        }
        label="Adendo Contratual"
      />

      {isChecked && (
        <TextField
          type="date"
          label="Data do Contrato Original"
          name="dataContratoOriginal"
          value={campos.dataContratoOriginal}
          onChange={handleChange}
          onPaste={handlePaste}
          InputLabelProps={{
            shrink: true,
          }}
          style={{ width: '200px' }}
        />

      )}


      <Box paddingTop={10}>
        <Grid container spacing={3}>

          <Grid item xs={12}>
            <TextField fullWidth onChange={handleChange}
              name='sistemaContratado' label="Sistema Contratado"
              variant="outlined" select>
              <MenuItem value="SISCHEF">SISTEMA SISCHEF</MenuItem>
              <MenuItem value="SISAGIL">SISTEMA SISAGIL</MenuItem>
              <MenuItem value="QRPEDIR">SISTEMA QRPEDIR</MenuItem>
            </TextField>
          </Grid>


          <Grid item xs={12}>
            <TextField fullWidth onChange={handleChange} name='razaoSocial' label="Razão social" variant="outlined" />
          </Grid>

          <Grid item xs={6}>
            <TextField fullWidth onChange={handleChange} name='cnpj' label="CNPJ" variant="outlined" />
          </Grid>

          <Grid item xs={6}>
            <TextField fullWidth onChange={handleChange} name='inscricaoEstadual' label="Inscricao Estadual" variant="outlined" />
          </Grid>

          <Grid item xs={12}>
            <TextField fullWidth onChange={handleChange} name='enderecoEmpresa' label="Endereço completo da empresa" variant="outlined" />
          </Grid>

          <Grid item xs={12}>
            <TextField fullWidth onChange={handleChange} name='representadaPor' label="Representada Por" variant="outlined" />
          </Grid>

          <Grid item xs={6}>
            <TextField fullWidth onChange={handleChange} name='cpf' label="CPF" variant="outlined" />
          </Grid>

          <Grid item xs={6}>
            <TextField fullWidth onChange={handleChange} name='rg' label="RG" variant="outlined" />
          </Grid>

          <Grid item xs={12}>
            <TextField fullWidth onChange={handleChange} name='enderecoRepresentante' label="Endereço" variant="outlined" />
          </Grid>

          <Grid item xs={12}>
            <TextField fullWidth onChange={handleChange} name='email' label="E-mail" variant="outlined" />
          </Grid>

          <Grid item xs={4}>
            <FormControl fullWidth variant="outlined" className={classes.formControl}>
              <InputLabel shrink id="diaVencimento">Dia do vencimento</InputLabel>
              <Select
                fullWidth
                label="Dia do vencimento"
                defaultValue='10'
                labelId="diaVencimento"
                name="diaVencimento"
                onChange={handleChange}
              >
                <MenuItem fullWidth value='5'>5</MenuItem>
                <MenuItem value='10'>10</MenuItem>
                <MenuItem value='15'>15</MenuItem>
                <MenuItem value='20'>20</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={4}>

            <FormControl fullWidth variant="outlined" className={classes.formControl}>
              <InputLabel id="mesCorrecao">Mês correção</InputLabel>
              <Select
                label="Mês correção"
                labelId="mesCorrecao"
                id="mesCorrecao"
                name="mesCorrecao"
                onChange={handleChange}
              >
                <MenuItem value='JANEIRO'>JANEIRO</MenuItem>
                <MenuItem value='FEVEREIRO'>FEVEREIRO</MenuItem>
                <MenuItem value='MARÇO'>MARÇO</MenuItem>
                <MenuItem value='ABRIL'>ABRIL</MenuItem>
                <MenuItem value='MAIO'>MAIO</MenuItem>
                <MenuItem value='JUNHO'>JUNHO</MenuItem>
                <MenuItem value='JULHO'>JULHO</MenuItem>
                <MenuItem value='AGOSTO'>AGOSTO</MenuItem>
                <MenuItem value='SETEMBRO'>SETEMBRO</MenuItem>
                <MenuItem value='OUTUBRO'>OUTUBRO</MenuItem>
                <MenuItem value='NOVEMBRO'>NOVEMBRO</MenuItem>
                <MenuItem value='DEZEMBRO'>DEZEMBRO</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={4}>
            <FormControl fullWidth variant="outlined" className={classes.formControl}>
              <InputLabel shrink id="periodicidade">Periodicidade</InputLabel>
              <Select
                fullWidth
                label="Periodicidade do pagamento"
                defaultValue='12'
                labelId="periodicidade"
                name="periodicidade"
                onChange={handleChange}
                value={campos.periodicidade || ''}
              >
                <MenuItem value='MENSAL'>Mensal</MenuItem>
                <MenuItem value='TRIMESTRAL'>Trimestral</MenuItem>
                <MenuItem value='SEMESTRAL'>Semestral</MenuItem>
                <MenuItem value='ANUAL'>Anual</MenuItem>
                <MenuItem value='BIANUAL'>Bianual</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              onChange={handleChange}
              name="planoSelecionado"
              label="Plano"
              variant="outlined"

              select
              value={campos.planoSelecionado || ''}  // controlado
            >
              <MenuItem value="ECONOMY">
                {`Economy — ${formatBRL(PLANOS_2025.ECONOMY.mensalidade)}/mês • implantação ${formatBRL(PLANOS_2025.ECONOMY.implantacao)}`}
              </MenuItem>
              <MenuItem value="ENTERPRISE">
                {`Enterprise — ${formatBRL(PLANOS_2025.ENTERPRISE.mensalidade)}/mês • implantação ${formatBRL(PLANOS_2025.ENTERPRISE.implantacao)}`}
              </MenuItem>
              <MenuItem value="PREMIUM">
                {`Premium — ${formatBRL(PLANOS_2025.PREMIUM.mensalidade)}/mês • implantação ${formatBRL(PLANOS_2025.PREMIUM.implantacao)}`}
              </MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              multiline
              // InputProps={{ readOnly: true }}
              fullWidth
              minRows={10}
              maxRows={20}
              onChange={handleChange}
              name='plano'
              label='Plano Contratado'
              variant='outlined'
              value={campos.plano || ''}   // <-- novo
            />
          </Grid>

          {/* <Grid item xs={12}>
            <TextField fullWidth onChange={handleChange}
              name='formato' label="Formato treinamento"
              variant="outlined" select>
              <MenuItem value="EAD - Sympla">EAD - Sympla</MenuItem>
              <MenuItem value="Via Meet (videoConferencia)">Via Meet (videoConferencia)</MenuItem>
            </TextField>

          </Grid> */}

          <Grid item xs={2}>
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="valorImplantacao">Implantação</InputLabel>
              <OutlinedInput
                id="valorImplantacao"
                name="valorImplantacao"
                type="number"
                value={campos.valorImplantacao || ''}         // <-- novo
                inputProps={{ step: '0.01' }}                 // <-- ajuda com decimais
                onChange={handleChange}
                startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                labelWidth={130}
              />
            </FormControl>
          </Grid>

          <Grid item xs={8}>
            <TextField fullWidth onChange={handleChange} value={campos.valorImplantacaoExtenso} name='valorImplantacaoExtenso' InputLabelProps={{ shrink: true }} label="Valor implantação extenso" variant="outlined" />
          </Grid>

          <Grid item xs={2}>
            <TextField
              fullWidth
              select
              name="formaPagamentoImplantacao"
              label="Forma pag."
              variant="outlined"
              value={campos.formaPagamentoImplantacao || 'PIX'}
              onChange={handleChange}
            >
              <MenuItem value="PIX">PIX</MenuItem>
              <MenuItem value="CARTAO">Cartão</MenuItem>
              <MenuItem value="BOLETO">Boleto</MenuItem>
            </TextField>
          </Grid>



          <Grid item xs={2}>
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="valorMensalidade">Mensalidade</InputLabel>
              <OutlinedInput
                id="valorMensalidade"
                name="valorMensalidade"
                type="number"
                value={campos.valorMensalidade || ''}         // <-- novo
                inputProps={{ step: '0.01' }}                 // <-- ajuda com decimais
                onChange={handleChange}
                startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                labelWidth={140}
              />
            </FormControl>
          </Grid>

          <Grid item xs={8}>
            <TextField fullWidth onChange={handleChange} value={campos ? campos.valorMensalidadeExtenso : ''} name='valorMensalidadeExtenso' InputLabelProps={{ shrink: true }} label="Valor mensalidade extenso" variant="outlined" />
          </Grid>

          <Grid item xs={2}>
            <TextField
              fullWidth
              select
              name="formaPagamentoMensalidade"
              label="Forma pag."
              variant="outlined"
              value={campos.formaPagamentoMensalidade || 'PIX'}
              onChange={handleChange}
            >
              <MenuItem value="PIX">PIX</MenuItem>
              <MenuItem value="CARTAO">Cartão</MenuItem>
              <MenuItem value="BOLETO">Boleto</MenuItem>
            </TextField>
          </Grid>


          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              label="Trimestral (-3%)"
              value={campos.valorTrimestral || ''}
              InputProps={{ readOnly: true }}
              size='small'
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={9}>
            <TextField
              fullWidth
              label="Trimestral por extenso"
              value={campos.valorTrimestralExtenso || ''}
              InputProps={{ readOnly: true }}
              size='small'
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              label="Semestral (-6%)"
              value={campos.valorSemestral || ''}
              InputProps={{ readOnly: true }}
              variant="outlined"
              size='small'
            />
          </Grid>
          <Grid item xs={12} sm={6} md={9}>
            <TextField
              fullWidth
              label="Semestral por extenso"
              value={campos.valorSemestralExtenso || ''}
              InputProps={{ readOnly: true }}
              variant="outlined"
              size='small'
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              label="Anual (-12%)"
              value={campos.valorAnual || ''}
              InputProps={{ readOnly: true }}
              variant="outlined"
              size='small'
            />
          </Grid>
          <Grid item xs={12} sm={6} md={9}>
            <TextField
              fullWidth
              label="Anual por extenso"
              value={campos.valorAnualExtenso || ''}
              InputProps={{ readOnly: true }}
              variant="outlined"
              size='small'
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              label="Bienal (-24%)"
              value={campos.valorBienal || ''}
              InputProps={{ readOnly: true }}
              variant="outlined"
              size='small'
            />
          </Grid>
          <Grid item xs={12} sm={6} md={9}>
            <TextField
              fullWidth
              label="Bienal por extenso"
              value={campos.valorBienalExtenso || ''}
              InputProps={{ readOnly: true }}
              variant="outlined"
              size='small'
            />
          </Grid>

          <Grid item xs={2}>
            <TextField
              id="horaTreinamento"
              name="horaTreinamento"
              label="Horas treinamento"
              type="tel"
              onChange={handleChange}
              value={campos.horaTreinamento || ''}
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={10}>
            <TextField
              fullWidth
              onChange={handleChange}
              value={campos ? campos.horaTreinamentoExtenso : ''}
              name='horaTreinamentoExtenso'
              InputLabelProps={{ shrink: true }}
              id="horaTreinamentoExtenso"
              label="horas treinamento extenso"
              variant="outlined" />
          </Grid>

          <Grid item xs={12}>
            <TextField
              multiline
              rows={6}
              fullWidth
              onChange={handleChange}
              name='resumoPagamento'
              label='Resumo pagamento (gerado automaticamente — pode editar)'
              variant='outlined'
              value={campos.resumoPagamento || ''}
            />
          </Grid>

          <Grid item xs={12} align='center'>
            <Button fullWidth variant='outlined' color='secondary' onClick={onclickSave} >Salvar</Button>
          </Grid>
        </Grid>
      </Box>

    </Container >
  );
}
